var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.orderInfo),function(info){return _c('span',{key:info.label},[_c('el-tooltip',{attrs:{"placement":"top-start","content":info.label,"open-delay":500}},[_c('el-tag',{attrs:{"type":info.type,"effect":"plain"}},[_vm._v("\n        "+_vm._s(info.content)+"\n      ")])],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }